import {
  POST_APPLICATION_SERVICE_ONBOARDING,
  POST_APPLICATION_SERVICE_ONBOARDING_FAIL,
  POST_APPLICATION_SERVICE_ONBOARDING_SUCCESS,
  POST_CLOUD_ONBOARDING,
  POST_CLOUD_ONBOARDING_FAIL,
  POST_GCP_ONBOARDING,
  POST_GCP_ONBOARDING_FAIL,
  POST_CREATE_RESOURCE_ALERTS,
  POST_CREATE_RESOURCE_ALERTS_FAIL,
  POST_INITIAL_ONBOARDING,
  POST_INITIAL_ONBOARDING_FAIL,
  POST_MAP_RESOURCE_TO_EMAIL,
  POST_MAP_RESOURCE_TO_EMAIL_FAIL,
  POST_NEW_RELIC_CREATE_RESOURCE_ALERTS,
  POST_NEW_RELIC_CREATE_RESOURCE_ALERTS_FAIL,
  POST_NEW_RELIC_ONBOARDING,
  POST_NEW_RELIC_ONBOARDING_FAIL,
  POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS,
  POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS_FAIL,
  POST_NEW_RELIC_UPDATE_ALERS,
  POST_NEW_RELIC_UPDATE_ALERS_FAIL,
  POST_OPSGENIE_ONBOARDING,
  POST_PAGERDUTY_ONBOARDING,
  POST_PAGERDUTY_ONBOARDING_FAIL,
  POST_RESOURCE_DISABLE_ALERTS,
  POST_RESOURCE_DISABLE_ALERTS_FAIL,
  POST_SERVICE_ONBOARDING,
  POST_SERVICE_ONBOARDING_FAIL,
  POST_UPDATE_ALERS,
  POST_UPDATE_ALERS_FAIL,
  PUT_NEW_RELIC_ALERTS,
  PUT_NEW_RELIC_ALERTS_FAIL,
  PUT_NEW_RELIC_THRESHOLD,
  PUT_NEW_RELIC_THRESHOLD_FAIL,
  PUT_THRESHOLD,
  PUT_THRESHOLD_FAIL,
  POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS,
  POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS,
  POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS_FAIL,
  POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS_FAIL,
  POST_AZURE_ONBOARDING_FAIL,
  POST_AZURE_ONBOARDING,
  POST_DATADOG_ONBOARDING,
  POST_DATADOG_ONBOARDING_FAIL,
  POST_DATADOG_ONBOARDING_SUCCESS,
  TEST_AWS_CONNECTION,
  TEST_AWS_CONNECTION_FAIL,
  TEST_AWS_CONNECTION_SUCCESS,
  TEST_AZURE_CONNECTION,
  TEST_AZURE_CONNECTION_FAIL,
  TEST_AZURE_CONNECTION_SUCCESS,
  TEST_GCP_CONNECTION,
  TEST_GCP_CONNECTION_FAIL,
  TEST_GCP_CONNECTION_SUCCESS,
  POST_APP_DYNAMICS_ONBOARDING_SUCCESS,
  POST_APP_DYNAMICS_ONBOARDING_FAIL,
  POST_APP_DYNAMICS_ONBOARDING,
  POST_SPLUNK_ONBOARDING,
  POST_SPLUNK_ONBOARDING_FAIL,
  POST_SPLUNK_ONBOARDING_SUCCESS,
  POST_DYNATRACE_ONBOARDING_SUCCESS,
  POST_DYNATRACE_ONBOARDING_FAIL,
  POST_DYNATRACE_ONBOARDING,
  GET_ALL_AWS_ACCOUNTS,
  GET_ALL_AWS_ACCOUNTS_FAIL,
  GET_ALL_AWS_ACCOUNTS_SUCCESS,
  DELETE_AWS_ACCOUNT,
  DELETE_AWS_ACCOUNT_FAIL,
  DELETE_AWS_ACCOUNT_SUCCESS,
  GET_ENCRYPTED_ORG_ID,
  GET_ENCRYPTED_ORG_ID_FAIL,
  GET_ENCRYPTED_ORG_ID_SUCCESS,
  POST_OCI_ONBOARDING,
  POST_OCI_ONBOARDING_FAIL,
  TEST_OCI_CONNECTION_SUCCESS,
  TEST_OCI_CONNECTION,
  TEST_OCI_CONNECTION_FAIL,
  TEST_SENTRY_CONNECTION,
  TEST_SENTRY_CONNECTION_SUCCESS,
  TEST_SENTRY_CONNECTION_FAIL,
  POST_SENTRY_ONBOARDING,
  POST_SENTRY_ONBOARDING_FAIL,
  RESET_SENTRY_STATES,
  TEST_LOKI_CONNECTION,
  TEST_LOKI_CONNECTION_SUCCESS,
  TEST_LOKI_CONNECTION_FAIL,
  POST_LOKI_ONBOARDING,
  POST_LOKI_ONBOARDING_FAIL,
  RESET_LOKI_STATES,
  TEST_CORALOGIX_CONNECTION,
  TEST_CORALOGIX_CONNECTION_SUCCESS,
  TEST_CORALOGIX_CONNECTION_FAIL,
  POST_CORALOGIX_ONBOARDING,
  POST_CORALOGIX_ONBOARDING_FAIL,
  RESET_CORALOGIX_STATES,
  GET_ALL_AZURE_ACCOUNTS_FAIL,
  GET_ALL_AZURE_ACCOUNTS_SUCCESS,
  GET_ALL_AZURE_ACCOUNTS,
  POST_GRAFANA_ONBOARDING,
  POST_GRAFANA_ONBOARDING_FAIL,
  GET_ALL_GCP_PROJECTS,
  GET_ALL_GCP_PROJECTS_SUCCESS,
  GET_ALL_GCP_PROJECTS_FAIL,
  POST_SIGNOZ_ONBOARDING,
  POST_SIGNOZ_ONBOARDING_FAIL,
  GET_ALL_NEW_RELIC_ACCOUNTS,
  GET_ALL_NEW_RELIC_ACCOUNTS_FAIL,
  GET_ALL_NEW_RELIC_ACCOUNTS_SUCCESS,
  DELETE_NEW_RELIC_ACCOUNT,
  DELETE_NEW_RELIC_ACCOUNT_FAIL,
  DELETE_NEW_RELIC_ACCOUNT_SUCCESS, TEST_SIGNOZ_CONNECTION, TEST_SIGNOZ_CONNECTION_FAIL, TEST_SIGNOZ_CONNECTION_SUCCESS,
} from "./actionTypes";

// cloud onboarding data

export const postCloudOnboarding = (cloud_onboarding, is_last_step, history) => {
  return {
    type: POST_CLOUD_ONBOARDING,
    payload: { cloud_onboarding, is_last_step, history }
  }
}

export const postGCPOnboarding = (gcp_onboarding, is_last_step, history) => {
  return {
    type: POST_GCP_ONBOARDING,
    payload: { gcp_onboarding, is_last_step, history }
  }
}
export const postAzureOnboarding = (azure_onboarding, is_last_step, history) => {
  return{
    type:POST_AZURE_ONBOARDING,
    payload: { azure_onboarding, is_last_step, history }
  }
}
export const postNewRelicOnboarding = (cloud_onboarding, is_last_step, history) => {
  return {
    type: POST_NEW_RELIC_ONBOARDING,
    payload: { cloud_onboarding, is_last_step, history }
  }
}

export const postNewRelicOnboardingFail = error => ({
  type: POST_NEW_RELIC_ONBOARDING_FAIL,
  payload: error,
})

export const postGrafanaOnboarding = (cloud_onboarding, is_last_step, history) => {
  return {
    type: POST_GRAFANA_ONBOARDING,
    payload: { cloud_onboarding, is_last_step, history }
  }
}

export const postGrafanaOnboardingFail = error => ({
  type: POST_GRAFANA_ONBOARDING_FAIL,
  payload: error,
})

export const postSignozOnboarding = (cloud_onboarding, is_last_step, history) => {
  return {
    type: POST_SIGNOZ_ONBOARDING,
    payload: { cloud_onboarding, is_last_step, history }
  }
}

export const postSignozOnboardingFail = error => ({
  type: POST_SIGNOZ_ONBOARDING_FAIL,
  payload: error,
})

export const postCloudOnboardingFail = error => ({
  type: POST_CLOUD_ONBOARDING_FAIL,
  payload: error,
})

export const postGCPOnboardingFail = error => ({
  type: POST_GCP_ONBOARDING_FAIL,
  payload: error,
})

export const postAzureOnboardingFail = error => ({
  type:POST_AZURE_ONBOARDING_FAIL,
  payload: error,
})
export const postServiceOnboarding = (service_onboarding, history) => {
  return {
    type: POST_SERVICE_ONBOARDING,
    payload: { service_onboarding, history }
  }
}

export const postServiceOnboardingFail = error => ({
  type: POST_SERVICE_ONBOARDING_FAIL,
  payload: error,
})


export const postInitialOnboarding = (master_systems, notification_channels) => {
  return {
    type: POST_INITIAL_ONBOARDING,
    payload: { master_systems, notification_channels }
  }
}

export const postInitialOnboardingFail = error => ({
  type: POST_INITIAL_ONBOARDING_FAIL,
  payload: error,
})

export const postOpsGenieOnboarding = (opsgenie_onboarding, is_last_step, history) => {
  return {
    type: POST_OPSGENIE_ONBOARDING,
    payload: { opsgenie_onboarding, is_last_step, history }
  }
}

export const postOpsGenieOnboardingFail = error => ({
  type: POST_CLOUD_ONBOARDING_FAIL,
  payload: error,
})

export const postPagerdutyOnboarding = (pagerduty_onboarding, is_last_step, history) => {
  return {
    type: POST_PAGERDUTY_ONBOARDING,
    payload: { pagerduty_onboarding, is_last_step, history }
  }
}

export const postPagerdutyOnboardingFail = error => ({
  type: POST_PAGERDUTY_ONBOARDING_FAIL,
  payload: error,
})

export const postApplicationServiceOnboarding = (application_service, is_last_step, history) => {
  return {
    type: POST_APPLICATION_SERVICE_ONBOARDING,
    payload: { application_service, is_last_step, history }
  }
}

export const postApplicationServiceOnboardingSuccess = application_service => {
  return {
    type: POST_APPLICATION_SERVICE_ONBOARDING_SUCCESS,
    payload: application_service
  }
}

export const postApplicationServiceOnboardingFail = error => ({
  type: POST_APPLICATION_SERVICE_ONBOARDING_FAIL,
  payload: error,
})

export const postUpdateAlerts = (alerts, history) => {
  return {
    type: POST_UPDATE_ALERS,
    payload: { alerts, history }
  }
}

export const postUpdateAlertsFail = error => ({
  type: POST_UPDATE_ALERS_FAIL,
  payload: error,
})

export const postResourceDisableAlerts = (alerts, history) => {
  return {
    type: POST_RESOURCE_DISABLE_ALERTS,
    payload: { alerts, history }
  }
}

export const postResourceDisableAlertsFail = error => ({
  type: POST_RESOURCE_DISABLE_ALERTS_FAIL,
  payload: error,
})

export const putThreshold = (thresholds) => {
  return {
    type: PUT_THRESHOLD,
    payload: { thresholds }
  }
}

export const putThresholdFail = error => ({
  type: PUT_THRESHOLD_FAIL,
  payload: error,
})

export const postMapResourceToEmail = (service) => {
  return {
    type: POST_MAP_RESOURCE_TO_EMAIL,
    payload: { service }
  }
}

export const postMapResourceToEmailFail = error => ({
  type: POST_MAP_RESOURCE_TO_EMAIL_FAIL,
  payload: error,
})

export const postCreateResourceAlerts = (alerts) => {
  return {
    type: POST_CREATE_RESOURCE_ALERTS,
    payload: { alerts }
  }
}

export const postCreateResourceAlertsFail = error => ({
  type: POST_CREATE_RESOURCE_ALERTS_FAIL,
  payload: error,
})

// New Relic Actions

export const postNewRelicResourceDisableAlerts = (alerts, history) => {
  return {
    type: POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS,
    payload: { alerts, history }
  }
}

export const postNewRelicResourceDisableAlertsFail = error => ({
  type: POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS_FAIL,
  payload: error,
})

export const putNewRelicAlerts = (alerts) => {
  return {
    type: PUT_NEW_RELIC_ALERTS,
    payload: { alerts }
  }
}

export const putNewRelicAlertsFail = error => ({
  type: PUT_NEW_RELIC_ALERTS_FAIL,
  payload: error,
})

export const postNewRelicUpdateAlerts = (alerts, history) => {
  return {
    type: POST_NEW_RELIC_UPDATE_ALERS,
    payload: { alerts, history }
  }
}

export const postNewRelicUpdateAlertsFail = error => ({
  type: POST_NEW_RELIC_UPDATE_ALERS_FAIL,
  payload: error,
})

export const postNewRelicCreateResourceAlerts = (alerts) => {
  return {
    type: POST_NEW_RELIC_CREATE_RESOURCE_ALERTS,
    payload: { alerts }
  }
}

export const postNewRelicCreateResourceAlertsFail = error => ({
  type: POST_NEW_RELIC_CREATE_RESOURCE_ALERTS_FAIL,
  payload: error,
})

export const putNewRelicThreshold = (thresholds) => {
  return {
    type: PUT_NEW_RELIC_THRESHOLD,
    payload: { thresholds }
  }
}

export const putNewRelicThresholdFail = error => ({
  type: PUT_NEW_RELIC_THRESHOLD_FAIL,
  payload: error,
})

export const postNewRelicDisableThresholdAlerts = (alerts) => {
  return {
    type: POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS,
    payload: { alerts }
  }
}

export const postNewRelicEnableThresholdAlerts = (alerts) => {
  return {
    type: POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS,
    payload: { alerts }
  }
}

export const postNewRelicEnableThresholdAlertsFail = error => ({
  type: POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS_FAIL,
  payload: error,
})

export const postNewRelicDisableThresholdAlertsFail = error => ({
  type: POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS_FAIL,
  payload: error,
})

// End New Relic Actions

export const postSplunkOnboarding = (splunk_onboarding, is_last_step, history) => {
    return {
      type: POST_SPLUNK_ONBOARDING,
      payload: {splunk_onboarding, is_last_step, history}
    }
}

export const postSplunkOnboardingFail = error => ({
    type: POST_SPLUNK_ONBOARDING_FAIL,
    payload: error,
})

export const postOciOnboarding = (oci_onboarding, is_last_step, history) => {
    return {
        type: POST_OCI_ONBOARDING,
        payload: { oci_onboarding, is_last_step, history }
    }
}

export const postOciOnboardingFail = error => ({
    type: POST_OCI_ONBOARDING_FAIL,
    payload: error,
})

export const postSentryOnboarding = (sentry_onboarding, is_last_step, history) => {
    return {
        type: POST_SENTRY_ONBOARDING,
        payload: { sentry_onboarding, is_last_step, history }
    }
}

export const postSentryOnboardingFail = error => ({
    type: POST_SENTRY_ONBOARDING_FAIL,
    payload: error,
})

export const postLokiOnboarding = (loki_onboarding, is_last_step, history) => {
    return {
        type: POST_LOKI_ONBOARDING,
        payload: { loki_onboarding, is_last_step, history }
    }
}

export const postLokiOnboardingFail = error => ({
    type: POST_LOKI_ONBOARDING_FAIL,
    payload: error,
})

export const postCoralogixOnboarding = (coralogix_onboarding, is_last_step, history) => {
    return {
        type: POST_CORALOGIX_ONBOARDING,
        payload: { coralogix_onboarding, is_last_step, history }
    }
}

export const postCoralogixOnboardingFail = error => ({
    type: POST_CORALOGIX_ONBOARDING_FAIL,
    payload: error,
})


export const postSplunkOnboardingSuccess = splunk_onboarding => {
    return {
      type: POST_SPLUNK_ONBOARDING_SUCCESS,
      payload: splunk_onboarding
    }
}


export const postDatadogOnboarding = (datadog_onboarding, is_last_step, history) => {
  return {
    type: POST_DATADOG_ONBOARDING,
    payload: { datadog_onboarding, is_last_step, history }
  }
}

export const postDatadogOnboardingFail = error => ({
  type: POST_DATADOG_ONBOARDING_FAIL,
  payload: error,
})

export const postDatadogOnboardingSuccess = datadog_onboarding => {
  return {
    type: POST_DATADOG_ONBOARDING_SUCCESS,
    payload: datadog_onboarding
  }
}

export const postAppDynamicsOnboarding = (appdynamics_onboarding, is_last_step, history) => {
    return {
        type: POST_APP_DYNAMICS_ONBOARDING,
        payload: { appdynamics_onboarding, is_last_step, history }
    }
}

export const postAppDynamicsOnboardingFail = error => ({
  type: POST_APP_DYNAMICS_ONBOARDING_FAIL,
    payload: error,
})

export const postAppDynamicsOnboardingSuccess = appdynamics_onboarding => ({
    type: POST_APP_DYNAMICS_ONBOARDING_SUCCESS,
    payload: appdynamics_onboarding,
})

export const postTestAWSCredentials = (cloud_onboarding, is_last_step, history) => {
  return {
    type: TEST_AWS_CONNECTION,
    payload: { cloud_onboarding, is_last_step, history }
  }
}

export const postTestGCPCredentials = (gcp_onboarding) => {
  return {
    type: TEST_GCP_CONNECTION,
    payload: { gcp_onboarding}
  }
}
export const postTestAzureCredentials = (azure_onboarding) => {
  return{
    type:TEST_AZURE_CONNECTION,
    payload: { azure_onboarding}
  }
}


export const postTestAWSCredentialsFail = error => ({
  type: TEST_AWS_CONNECTION_FAIL,
  payload: error,
})

export const postTestGCPCredentialsFail = error => ({
  type: TEST_GCP_CONNECTION_FAIL,
  payload: error,
})

export const postTestAzureCredentialsFail = error => ({
  type:TEST_AZURE_CONNECTION_FAIL,
  payload: error,
})


export const postTestAWSCredentialsSuccess = message => ({
  type: TEST_AWS_CONNECTION_SUCCESS,
  payload: message,
})

export const postTestGCPCredentialsSuccess = message => ({
  type: TEST_GCP_CONNECTION_SUCCESS,
  payload: message,
})

export const postTestAzureCredentialsSuccess= message => ({
  type:TEST_AZURE_CONNECTION_SUCCESS,
  payload: message,
})

export const postDynatraceOnboarding = (dynatrace_onboarding, is_last_step, history) => {
  return {
    type: POST_DYNATRACE_ONBOARDING,
    payload: { dynatrace_onboarding, is_last_step, history}
  }
}


export const postDynatraceOnboardingFail = error => ({
    type: POST_DYNATRACE_ONBOARDING_FAIL,
    payload: error,
})

export const postDynatraceOnboardingSuccess = dynatrace_onboarding => ({
    type: POST_DYNATRACE_ONBOARDING_SUCCESS,
    payload: dynatrace_onboarding
})

export const getAllAWSAccounts = () => {
    return {
        type: GET_ALL_AWS_ACCOUNTS,
    }
}

export const getAllAWSAccountsFail = error => ({
    type: GET_ALL_AWS_ACCOUNTS_FAIL,
    payload: error,
})

export const getAllAWSAccountsSuccess = aws_accounts => ({
    type: GET_ALL_AWS_ACCOUNTS_SUCCESS,
    payload: aws_accounts,
})

export const deleteAwsAccount = monitoring_system_id => {
    return {
        type: DELETE_AWS_ACCOUNT,
        payload:monitoring_system_id
    }
}

export const deleteAwsAccountFail = error => ({
    type: DELETE_AWS_ACCOUNT_FAIL,
    payload: error,
})

export const deleteAwsAccountSuccess = aws_account_deleted => ({
    type: DELETE_AWS_ACCOUNT_SUCCESS,
    payload: aws_account_deleted,
})


export const getEncytpedOrgId = () => {
    return {
        type: GET_ENCRYPTED_ORG_ID,
    }
}

export const getEncytpedOrgIdFail = error => ({
    type: GET_ENCRYPTED_ORG_ID_FAIL,
    payload: error,
})

export const getEncytpedOrgIdSuccess = encrypted_org_id => ({
    type: GET_ENCRYPTED_ORG_ID_SUCCESS,
    payload: encrypted_org_id,
})

export const postTestOCICredentials = (oci_onboarding) => {
  return{
    type:TEST_OCI_CONNECTION,
    payload: { oci_onboarding}
  }
}

export const postTestOCICredentialsSuccess = message => ({
  type: TEST_OCI_CONNECTION_SUCCESS,
  payload: message,
})

export const postTestOCICredentialsFail = error => ({
  type: TEST_OCI_CONNECTION_FAIL,
  payload: error,
})


export const postTestSentryCredentials = (sentry_onboarding) => {
  return{
    type:TEST_SENTRY_CONNECTION,
    payload: { sentry_onboarding}
  }
}

export const postTestSentryCredentialsSuccess = message => ({
  type: TEST_SENTRY_CONNECTION_SUCCESS,
  payload: message,
})

export const postTestSentryCredentialsFail = error => ({
  type: TEST_SENTRY_CONNECTION_FAIL,
  payload: error,
})

export const resetSentryStates = () => ({
  type: RESET_SENTRY_STATES
});

export const postTestLokiCredentials = (loki_onboarding) => {
  return{
    type:TEST_LOKI_CONNECTION,
    payload: { loki_onboarding}
  }
}

export const postTestLokiCredentialsSuccess = message => ({
  type: TEST_LOKI_CONNECTION_SUCCESS,
  payload: message,
})

export const postTestLokiCredentialsFail = error => ({
  type: TEST_LOKI_CONNECTION_FAIL,
  payload: error,
})

export const resetLokiStates = () => ({
  type: RESET_LOKI_STATES
});

export const postTestCoralogixCredentials = (coralogix_onboarding) => {
  return{
    type:TEST_CORALOGIX_CONNECTION,
    payload: { coralogix_onboarding}
  }
}

export const postTestCoralogixCredentialsSuccess = message => ({
  type: TEST_CORALOGIX_CONNECTION_SUCCESS,
  payload: message,
})

export const postTestCoralogixCredentialsFail = error => ({
  type: TEST_CORALOGIX_CONNECTION_FAIL,
  payload: error,
})

export const resetCoralogixStates = () => ({
  type: RESET_CORALOGIX_STATES
});


export const getAllAzureAccounts = () => ({
    type: GET_ALL_AZURE_ACCOUNTS,
})

export const getAllAzureAccountsFail = error => ({
  type: GET_ALL_AZURE_ACCOUNTS_FAIL,
  payload: error,
})

export const getAllAzureAccountsSuccess = azure_accounts => ({
  type: GET_ALL_AZURE_ACCOUNTS_SUCCESS,
  payload: azure_accounts,
})

export const getAllGcpProjects = () => ({
  type: GET_ALL_GCP_PROJECTS,
})

export const getAllGcpProjectsFail = error => ({
  type: GET_ALL_GCP_PROJECTS_FAIL,
  payload: error,
})

export const getAllGcpProjectsSuccess = gcp_projects => ({
  type: GET_ALL_GCP_PROJECTS_SUCCESS,
  payload: gcp_projects
})

export const deleteNewRelicAccount = monitoring_system_id => {
  return {
    type: DELETE_NEW_RELIC_ACCOUNT,
    payload:monitoring_system_id
  }
}

export const deleteNewRelicAccountFail = error => ({
  type: DELETE_NEW_RELIC_ACCOUNT_FAIL,
  payload: error,
})

export const deleteNewRelicAccountSuccess = newrelic_account_deleted => ({
  type: DELETE_NEW_RELIC_ACCOUNT_SUCCESS,
  payload: newrelic_account_deleted,
})

export const getNewRelicAccount = () => {
  return {
    type: GET_ALL_NEW_RELIC_ACCOUNTS,
  }
}

export const getNewRelicAccountFail = error => ({
  type: GET_ALL_NEW_RELIC_ACCOUNTS_FAIL,
  payload: error,
})

export const getNewRelicAccountSuccess = new_relic_account => ({
  type: GET_ALL_NEW_RELIC_ACCOUNTS_SUCCESS,
  payload: new_relic_account,
})

export const postTestSignozCredentials = (signoz_onboarding) => {
  return{
    type:TEST_SIGNOZ_CONNECTION,
    payload: signoz_onboarding
  }
}

export const postTestSignozCredentialsFail = error => ({
  type:TEST_SIGNOZ_CONNECTION_FAIL,
  payload: error,
})

export const postTestSignozCredentialsSuccess= message => ({
  type:TEST_SIGNOZ_CONNECTION_SUCCESS,
  payload: message,
})